<template>
  <div
    class="
    flex items-stretch
      relative
      z-20
      w-[10rem]
      shadow-md
      bg-base-100
      !border-1
      border-l-4 border-r-4 border
      rounded-l-lg rounded-r-lg
      border-secondary
      text-base-content
      backdrop-blur-lg
      animate-animated animate-fadeIn
    "
    :class="{
      '!border-rouge hover:bg-rouge/50 active:bg-rouge active:text-white':
        result.computedType == 1,
      '!border-vert hover:bg-vert/50 active:bg-vert active:text-white':
        result.computedType == 2,
      '!border-bleu hover:bg-bleu/50 active:bg-bleu active:text-white':
        result.computedType == 3,
      'cursor-pointer ': !draggable,
      'bg-gray-500 text-white': selected,
      'cursor-move': draggable
    }"
    :draggable="draggable"
    @dragstart="dragStart"
    @dragend="dragEnd"
    @click="doSelected"
  >
    <div class="flex items-center p-2 gap-x-2">
      <div
        v-if="result.computedType > 0"
        :class="{
          '!border-rouge': result.computedType == 1,
          '!border-vert': result.computedType == 2,
          '!border-bleu ': result.computedType == 3
        }"
        class="flex items-center self-center justify-center w-5 h-5 text-xs font-bold border rounded-full"
      >
        {{ result?.levelOfResult || 1 }}
      </div>
      <div class="text-base text-center">
        {{ result?.result?.name }}
      </div>
      <span class="hidden text-sm">{{ result?.result?.indication }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: ["draggable", "result", "selected"],
  mounted() {
    setTimeout(() => {
      this.$emit("report", {
        resultID: this.result.resultID,
        position: this.$el
      });
    }, 300);
  },

  watch: {
    draggable() {}
  },
  methods: {
    doSelected() {
      if (this.draggable) return;
      this.$emit("selected", this.$el, this.result.resultID, this.result);
    },
    dragStart(e) {
      e.dataTransfer.setData("resultID", this.result.resultID);

      setTimeout(() => {
        e.target.style.opacity = "0";
      }, 0);
    },
    dragEnd(e) {
      setTimeout(() => {
        e.target.style.opacity = "1";
      }, 0);
    }
  }
};
</script>

<style></style>
